<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div class="col-12 col-md-7 col-lg-6 auth-main-col text-center p-5">
    <div class="d-flex flex-column align-content-end">
      <div class="alert alert-danger" v-show="isError" v-html="errorMessage"></div>
      <div class="app-auth-body mx-auto" v-show="!isLoading">
        <div class="app-auth-branding mb-4 mt-4">
          <img class="logo-icon me-2 img-fluid" src="@/assets/images/logo-aff.png" alt="logo">
        </div>
        <h2 class="auth-heading text-center mb-3">New Member Join</h2>
        <div class="auth-form-container text-start">
          <form class="auth-form login-form" @submit.prevent="sendForm">
            <div class="email mb-3">
              <label class="sr-only" for="signup-email">Email</label>
              <input id="signup-email" name="email" v-model="form.user_username" type="text" class="form-control signup-email" placeholder="Email" required="required">
              <div class="text-danger fs13" v-show="hasError('user_username')" v-html="getError('user_username')"></div>
            </div><!--//form-group-->
            <div class="password mb-3">
              <label class="sr-only" for="signup-password">Password</label>
              <input id="signup-password" name="password" v-model="form.password" type="password" class="form-control signup-password" placeholder="Password" required="required">
              <div class="text-danger fs13" v-show="hasError('password')" v-html="getError('password')"></div>
            </div><!--//form-group-->
            <div class="password mb-3">
              <label class="sr-only" for="signup-repassword">Re-type Password</label>
              <input id="signup-repassword" name="repassword" v-model="form.repassword" type="password" class="form-control signup-password" placeholder="Re-type Password" required="required">
            </div><!--//form-group-->

            <div class="extra mb-3">
              <select class="form-select" v-model="form.messenger_id" @change="changeMessenger" required="required">
                <option v-for="(option, i) in messengers" :key="i" v-bind:value="option.value" :selected="option.selected">
                  {{ option.text }}
                </option>
              </select>
              <input class="form-control" v-model="form.messenger" type="text" :disabled="form.messenger_id === ''" placeholder="Messenger`s Phone, Name or ID"  required="required"/>
              <div class="text-danger fs13" v-show="hasError('messenger')" v-html="getError('messenger')"></div>
            </div>

            <div class="extra mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="agreeTerms" v-model="tos_agree" required="required">
                <label class="form-check-label" for="agreeTerms">
                  I read and agree <a href="https://romance-net.com/tos.php" class="app-link">Terms and Conditions</a>.
                </label>
                <div class="text-danger fs13" v-show="hasError('tos_agree')" v-html="getError('tos_agree')"></div>
              </div>
            </div>

            <div class="name mb-3">
              <label class="sr-only" for="signup-name">Your First Name</label>
              <input id="signup-name" name="first_name" v-model="form.user_firstname" type="text" class="form-control signup-email" placeholder="Enter Your first name">
              <div class="text-danger fs13" v-show="hasError('user_firstname')" v-html="getError('user_firstname')"></div>
            </div><!--//form-group-->

            <div class="captcha mb-3">
              <div class="row sample-captcha">
                <div class="col"><input type="text" class="form-control signup-email" v-model="captcha" placeholder="Captcha code" /></div>
                <div class="col-auto"><VueClientRecaptcha
                    :value="captcha"
                    :count="4"
                    @isValid="checkValidCaptcha"
                /></div>
              </div>
              <div class="text-danger fs13" v-show="hasError('captcha')" v-html="getError('captcha')"></div>
            </div>

            <div class="text-center">
              <button type="submit" class="btn btn-primary w-100 theme-btn mx-auto">Sign Up</button>
            </div>
          </form>

          <div class="auth-option text-center pt-5">Already have Account? Sign in <router-link class="text-link" to="/member/login" >here</router-link>.</div>
        </div><!--//auth-form-container-->

      </div><!--//auth-body-->
      <span v-if="isLoading" class="cssload-loader"><span class="cssload-loader-inner"></span></span>
      <div v-if="isLoading" class="mt-5" v-html="info"></div>
    </div><!--//flex-column-->
  </div><!--//auth-main-col-->
  <div class="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
    <div class="auth-background-login">
    </div>

  </div><!--//auth-background-col-->
</template>

<script>
import {
  errorMessage,
  isError,
  isLoading,
  loadingDone,
  doLoading,
  logout, authSuccess
} from "@/inc/storage";
import {getCookie, setCookie} from "@/inc/cookies"
import {getCsrf, Request} from "@/inc/client";
import VueClientRecaptcha from 'vue-client-recaptcha'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "SignupPage",
  components: {
    VueClientRecaptcha,
  },
  data() {
    return {
      form: {
        password: '',
        repassword: '',
        user_username: '',
        messenger: '',
        messenger_id: '',
        user_firstname: '',
        cid: undefined,
      },
      cid: undefined,
      tos_agree: 0,
      info : '',
      captcha : '',
      captcha_valid : false,
      errors : {},
      messengers: [
        { text: 'Select messenger', value: '', selected: true, disabled: true },
        { text: 'Telegram', value: 'telegram' },
        { text: 'Viber', value: 'viber' },
        { text: 'WhatsApp', value: 'whatsApp' },
        { text: 'Skype', value: 'skype' },
        { text: 'Other', value: 'other' },
      ],
    }
  },
  setup(){
    return {
      isLoading, isError, errorMessage
    }
  },
  mounted() {
    logout();
    this.init()
    loadingDone()
  },
  methods: {
    hasError : function (attr){
      // eslint-disable-next-line no-prototype-builtins
      return this.errors && this.errors.hasOwnProperty(attr)
    },
    getError : function (attr){
      // eslint-disable-next-line no-prototype-builtins
      return this.errors && this.errors.hasOwnProperty(attr) ? this.errors[attr] : '';
    },

    validate : function ()
    {
      this.errors = {};

      if (!this.form.password || this.form.password !== this.form.repassword) {
        this.errors['password'] = 'Empty password or not equals to re-type password';
      }
      if (!this.captcha_valid) {
        this.errors['captcha'] = 'Incorrect captcha code.';
      }
      if (!this.tos_agree) {
        this.errors['tos_agree'] = 'You must agreed Terms and Conditions';
      }

      return Object.keys(this.errors).length === 0
    },

    init : function ()
    {
      if (this.$route.query.cid)
      {
        setCookie('cid',this.$route.query.cid,7)
      }
    },

    sendForm: async function ()
    {
      if (!this.validate()) {
        return;
      }

      this.form.cid = getCookie('cid')
      let This = this;


      doLoading()
      let payload = {
        _csrf: await getCsrf(),
        Profile: this.form
      }

      Request('singup', {data: payload, method: 'POST'})
          .then(function (response)
          {
            if (response.data['success'] === 1) {
              This.info = 'Success join. Redirecting to login page...';

              Request('login', {
                data: {
                  LoginForm: {
                    username: payload.Profile.user_username,
                    password: payload.Profile.password
                  }
                }, method: 'POST'
              })
                  .then(function (resp)
                  {
                    authSuccess(resp.data)
                  })

            } else {
              This.errors = response.data.errors
              loadingDone();
            }
          })
          .catch(() =>
          {
            loadingDone();
          })
    },

    changeMessenger : function()
    {
      if (this.form.messenger_id === '')
      {
        this.form.messenger = '';
      }
    },
    checkValidCaptcha : function(value) {
      this.captcha_valid = value
    }
  }
}
</script>

<style scoped>
.vue_client_recaptcha{display:flex;justify-content:center;flex-direction:row}.vue_client_recaptcha_icon{text-align:center;padding:10px;cursor:pointer;display:flex;align-items:center;justify-content:center;background-color:#eee}.vue_client_recaptcha_icon:hover{background-color:#ccc}.vue_client_recaptcha .captcha_canvas{background:#eee;padding:10px 0}
</style>